import { useNavigate } from 'react-router'
import { useAppDispatch, useAppSelector } from './../../store/hooks'
import { LOGOUT } from './../endpoints'

import api from '../api'

import { BackendToUI } from '@/pages/conversion'
import { logoutThunk, persistor } from '@/store'
import { crumbCache } from '@/common/breadcrumbs/crumbCache'

const useLogout = () => {
  const dispatch = useAppDispatch()
  const userType = useAppSelector((state) => state.auth.user_type)
  const navigate = useNavigate()
  const logout = async () => {
    const currentUserType = userType
    try {
      api.post(
        LOGOUT,
        {},
        {
          withCredentials: true,
        }
      )
    } catch (err) {}
    dispatch(logoutThunk())
    await persistor.flush()
    await persistor.purge()
    crumbCache.clearAllCrumbs()
    navigate(`/${BackendToUI[currentUserType as 'admin']}/auth/sign-in`)
  }
  return logout
}

export default useLogout
